module.exports = __webpack_public_path__ + "media/virtual-gallery/GalleryFocus1-3e259b07.jpg";